module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-summary"
  }, [_c('div', {
    staticClass: "summary-title border-bottom"
  }, [_vm._v("Resumen de Compra")]), _vm._v(" "), _c('div', {
    staticClass: "summary-body"
  }, [_c('div', {
    staticClass: "summary-row"
  }, [_c('div', {
    staticClass: "summary-col bold"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('div', {
    staticClass: "summary-col right"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.amount))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row"
  }, [_c('div', {
    staticClass: "summary-col"
  }, [_vm._v("Envío")]), _vm._v(" "), _c('div', {
    staticClass: "summary-col right"
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.shippingPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "summary-row border-top"
  }, [_c('div', {
    staticClass: "summary-col summary-total"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "summary-col red-bold",
    style: (("color:" + (_vm.globalColors.primary)))
  }, [_vm._v(_vm._s(_vm.currencySymbol) + " " + _vm._s(_vm.total))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6516ea57","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/order-summary.vue
// module id = 1128
// module chunks = 2